import {
  AuthPartialState,
  loginSuccessAction,
  logoutSuccessAction,
} from 'users/reducers/auth';
import { AffiliateUser, NumericProject, PROJECT_BY_ID } from 'types/user';
import currentProjectIdSelector from 'users/selectors/currentProjectIdSelector';

import { FAVICON_LINKS_SELECTOR, LinkAttributes } from './constants';

const faviconChanger =
  ({ getState }) =>
  (next) =>
  (action) => {
    const result = next(action);

    switch (action.type) {
      case loginSuccessAction.type: {
        const state: AuthPartialState<AffiliateUser> = getState();

        const currentProjectId = currentProjectIdSelector(state);

        if (currentProjectId !== NumericProject.Stripchat) {
          const links: NodeListOf<HTMLLinkElement> = document.querySelectorAll(
            FAVICON_LINKS_SELECTOR,
          );

          if (links.length) {
            links.forEach((link) => {
              const sizes = link.getAttribute(LinkAttributes.Sizes);

              link.setAttribute(
                LinkAttributes.Href,
                `/icons/${PROJECT_BY_ID[currentProjectId]}-favicon-${sizes}.png`,
              );
            });
          }
        }
        break;
      }

      case logoutSuccessAction.type: {
        const links: NodeListOf<HTMLLinkElement> = document.querySelectorAll(
          FAVICON_LINKS_SELECTOR,
        );

        if (links.length) {
          links.forEach((link) => {
            const sizes = link.getAttribute(LinkAttributes.Sizes);
            const nextHref = `/icons/favicon-${sizes}.png`;

            if (link.getAttribute(LinkAttributes.Sizes) !== nextHref) {
              link.setAttribute(LinkAttributes.Href, nextHref);
            }
          });
        }
        break;
      }

      default:
        break;
    }

    return result;
  };

export default faviconChanger;
